const initialState = () => ({
  project: null,
  list: null,
  card: null,
  card_name: null,
  card_desc: null,
  card_type: null,
  card_priority: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign (
      state,
      { project, list, card, card_name, card_desc, card_type, card_priority }
    ) {
      state.project = project
      state.list = list
      state.card = card
      state.card_name = card_name
      state.card_desc = card_desc
      state.card_type = card_type
      state.card_priority = card_priority
    }
  }
}
